import { useTranslation } from 'react-i18next';
import { useAccountsLive } from '@/api/account/use-accounts-live';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { MovementForm } from '@/pages/accounts/form-movement';
import { PROTECTED, ACCOUNTS } from '@/lib/constants/routes';
import { useEffect, useRef } from 'react';
import { toast } from '@repo/ui/lib/toast';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { isCurrencyPart } from '@/pages/accounts/lib/currency-parts';

const RETURN_URL = `${PROTECTED}${ACCOUNTS}`;

export const Route = createFileRoute(
  '/protected/_layout/accounts/_layout/movements/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewMovementModal,
});

function NewMovementModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasShownToast = useRef(false);

  const handleClose = () => {
    navigate({
      to: RETURN_URL,
      search: (old) => old,
    });
  };

  const { data: accountsData, isLoading } = useAccountsLive();
  const accounts =
    accountsData?.filter(
      (account) => !account.isArchived && !isCurrencyPart(account)
    ) || [];

  const manualAccounts =
    accounts?.filter((account) => !account.externalId) || [];

  useEffect(() => {
    if (!isLoading && !manualAccounts.length && !hasShownToast.current) {
      hasShownToast.current = true;
      toast.error(t('cash_movement.create.no_account'));
      handleClose();
    }
  }, [isLoading, manualAccounts.length]);

  return <MovementForm returnUrl={RETURN_URL} />;
}
